/* eslint-disable jsx-a11y/mouse-events-have-key-events */
/* global google */

import React, { useState } from 'react';
import moment from 'moment';
import { withScriptjs, withGoogleMap, GoogleMap, Marker } from 'react-google-maps';
import { isMobile } from 'react-device-detect';

import { MarkerClusterer } from 'react-google-maps/lib/components/addons/MarkerClusterer';
import { InfoBox } from 'react-google-maps/lib/components/addons/InfoBox';

const GoogleMapComponentWithMarker = withScriptjs(
  withGoogleMap(({ settings, events }) => {
    const [show, setShow] = useState(null);

    return (
      <GoogleMap
        defaultZoom={isMobile ? 6.3 : 7}
        defaultCenter={{
          lat: 55.874336, // latitude for the center of the map
          lng: 10.094057, // longitude for the center of the map
        }}
        defaultOptions={{
          disableDefaultUI: true, // disable default map UI
          draggable: true, // make map draggable
          keyboardShortcuts: false, // disable keyboard shortcuts
          scrollwheel: false, // allow scroll wheel
          styles: settings.MAP_THEME, // change default map styles
          zoomControl: true,
          mapTypeControl: false,
          scaleControl: false,
          streetViewControl: false,
          rotateControl: false,
          fullscreenControl: true,
          controlSize: 24,
        }}
        onClick={() => {
          setTimeout(() => {
            setShow(null);
          }, 100);
        }}
      >
        <MarkerClusterer
          // onClick={markerClusterer => {
          //   // const clickedMarkers = markerClusterer.getMarkers();
          //   // console.log('props', markerClusterer, props);
          // }}
          averageCenter
          gridSize={settings.CLUSTER_GRID}
          zoomOnClick={false}
          styles={[
            {
              url: 'http://dixontest.dk/api-test/clustermarker.png',
              height: 35,
              width: 35,
            },
            {
              url: 'http://dixontest.dk/api-test/clustermarker.png',
              height: 35,
              width: 35,
            },
            {
              url: 'http://dixontest.dk/api-test/clustermarker.png',
              height: 35,
              width: 35,
            },
            {
              url: 'http://dixontest.dk/api-test/clustermarker.png',
              height: 35,
              width: 35,
            },
            {
              url: 'http://dixontest.dk/api-test/clustermarker.png',
              height: 35,
              width: 35,
            },
          ]}
        >
          {events.map(item => {
            const size = isMobile ? 12 : 16;
            return (
              <Marker
                key={item.id}
                icon={{
                  path: `M${size * 0.5 + size / 2},${size * 0.5}
 A${size / 2} ${size / 2} 0 1 0 ${size * 0.5 + size / 2} ${size * 0.5001}`,
                  fillColor: item.soldOut ? settings.PIN_SOLD_OUT_COLOR : settings.PIN_COLOR,
                  fillOpacity: 1,
                  strokeWeight: 0,
                  size: new google.maps.Size(size, size),
                  anchor: new google.maps.Point(size / 2, size / 2),
                  scale: show === item.id ? 1.2 : 1,
                }}
                position={{
                  lat: item.venueLatitude, // latitude to position the marker
                  lng: item.venueLongitude, // longitude to position the marker
                }}
                onMouseOver={() => {
                  setShow(item.id);
                }}
                onClick={() => {
                  setShow(item.id);
                }}
              >
                {show === item.id && (
                  <InfoBox
                    options={{
                      alignBottom: true,
                      pixelOffset: new google.maps.Size(-30, -10),
                      enableEventPropagation: true,
                    }}
                  >
                    <div className="map-info-box">
                      <div
                        className="inner-info-box"
                        onMouseLeave={() => {
                          setShow(null);
                        }}
                      >
                        <div className="date">{moment(item.eventDateTime).format('DD.MM.YY')}</div>
                        <div className="title">
                          {item.venueName}, {item.city}
                        </div>
                        <div className="buy">
                          <a
                            href={item.url}
                            className={`button ${item.soldOut ? 'soldout' : 'vacant'}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {item.soldOut ? 'UDSOLGT' : 'BILLETTER'}
                          </a>
                        </div>
                      </div>
                    </div>
                  </InfoBox>
                )}
              </Marker>
            );
          })}
        </MarkerClusterer>
      </GoogleMap>
    );
  }),
);

// Export Google Map component
export default GoogleMapComponentWithMarker;
